import {NgModule} from '@angular/core';
import {UrlSerializer} from '@angular/router';
import CustomUrlSerializer from './services/custom-url-serializer';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {RequestsTimeInterceptor} from './services/requests-time.interceptor';

const customUrlSerializer = new CustomUrlSerializer();

const CustomUrlSerializerProvider = {
  provide: UrlSerializer,
  useValue: customUrlSerializer,
};

@NgModule({
  providers: [
    CustomUrlSerializerProvider,
    {provide: HTTP_INTERCEPTORS, useClass: RequestsTimeInterceptor, multi: true},
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: CloudfrontHostHeaderInterceptor,
    //   multi: true,
    // },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: WordPressApiMonitorInterceptor,
    //   multi: true,
    // },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: SeoMetaInterceptor,
    //   multi: true,
    // },
  ],
})
export class AppInterceptorsModule {}
